import { theming } from '@glu/theming';

export default ({ buttons }) => ({
  root: {
    cursor: buttons.cursor,
    fontFamily: buttons.fontFamily,
    outlineOffset: buttons.outlineOffset,
    borderStyle: 'solid',
    lineHeight: 1,

    '&[aria-busy]': {
      position: 'relative',
      overflow: 'hidden',

      '&::before': {
        content: '""',
        boxSizing: 'border-box',
        position: 'absolute',
        display: 'inline-block',
        left: '50%',
        opacity: 0,
        top: '80%',
        marginTop: ({ size }) => -(buttons[size].spinnerSize / 2),
        marginLeft: ({ size }) => -(buttons[size].spinnerSize / 2),
        width: ({ size }) => buttons[size].spinnerSize,
        height: ({ size }) => buttons[size].spinnerSize,
        border: '2px solid',
        borderRadius: '50%',
        transitionDuration: '0.3s',
        transitionProperty: 'opacity, top',
        animationDuration: '1s',
        animationIterationCount: 'infinite',
        animationName: `${theming.useTheme ? '$' : ''}rotate`,
        animationTimingFunction: 'linear'
      },

      '&:after': {
        content: '""',
        display: 'inline-block',
        height: '100%',
        width: 0
      },

      '&[aria-busy="true"]': {
        pointerEvents: 'none',
        cursor: 'not-allowed',
        color: 'transparent',
        textAlign: 'left',

        '&::before': {
          opacity: 1,
          top: '50%',
          transitionDuration: '0.5s'
        }
      }
    }
  },

  normal: {
    borderRadius: buttons.normal.borderRadius,
    fontSize: buttons.normal.fontSize,
    padding: buttons.normal.padding
  },

  small: {
    borderRadius: buttons.small.borderRadius,
    fontSize: buttons.small.fontSize,
    padding: buttons.small.padding
  },

  extraSmall: {
    borderRadius: buttons.extraSmall.borderRadius,
    fontSize: buttons.extraSmall.fontSize,
    padding: buttons.extraSmall.padding
  },

  primary: {
    backgroundColor: buttons.primary.backgroundColor,
    borderColor: buttons.primary.borderColor,
    color: buttons.primary.textColor,
    textTransform: buttons.primary.textTransform,
    fontWeight: buttons.primary.fontWeight,

    '&:hover': {
      backgroundColor: buttons.primary.hoverColor,
      borderColor: buttons.primary.hoverColor
    },

    '&:focus': {
      outline: buttons.primary.outlineReplacement ? 'none' : undefined,
      boxShadow: buttons.primary.outlineReplacement,
      backgroundColor: buttons.primary.focusColor,
      borderColor: buttons.primary.focusColor
    },

    '&[aria-busy="true"]': {
      backgroundColor: buttons.primary.spinnerBackground,
      borderColor: buttons.primary.spinnerBorder,

      '&:before': {
        borderColor: [buttons.primary.spinnerColor, buttons.primary.spinnerColor, buttons.primary.spinnerColor, 'transparent']
      }
    },

    '&:disabled': {
      backgroundColor: buttons.primary.disabledBackground,
      borderColor: buttons.primary.disabledBorder,
      color: buttons.primary.disabledColor,
      cursor: 'not-allowed'
    }
  },
  secondary: {
    backgroundColor: buttons.secondary.backgroundColor,
    borderColor: buttons.secondary.borderColor,
    color: buttons.secondary.textColor,
    textTransform: buttons.secondary.textTransform,
    fontWeight: buttons.secondary.fontWeight,

    '&:focus, &:active': {
      backgroundColor: buttons.secondary.focusColor,
      borderColor: buttons.secondary.focusBorderColor
    },

    '&:focus': {
      outline: buttons.primary.outlineReplacement ? 'none' : undefined,
      boxShadow: buttons.primary.outlineReplacement
    },

    '&:hover': {
      backgroundColor: buttons.secondary.hoverColor,
      borderColor: buttons.secondary.borderColor
    },

    '&[aria-busy="true"]': {
      backgroundColor: buttons.secondary.spinnerBackground,
      borderColor: buttons.secondary.spinnerBorder,

      '&:before': {
        borderColor: [buttons.secondary.spinnerColor, buttons.secondary.spinnerColor, buttons.secondary.spinnerColor, 'transparent']
      }
    },

    '&:disabled': {
      backgroundColor: buttons.secondary.disabledBackground,
      borderColor: buttons.secondary.disabledBorder,
      color: buttons.secondary.disabledColor,
      cursor: 'not-allowed'
    }
  },
  tertiary: {
    backgroundColor: buttons.tertiary.backgroundColor,
    border: 'none',
    borderRadius: 0, // border: none doesn't remove border radius
    textDecoration: buttons.tertiary.textDecoration,
    color: buttons.tertiary.textColor,
    padding: buttons.tertiary.padding,

    '&:focus, &:active': {
      backgroundColor: buttons.tertiary.focusColor,
      textDecoration: buttons.tertiary.focusTextDecoration,
      outlineColor: buttons.focusColor
    },

    '&:hover': {
      backgroundColor: buttons.tertiary.hoverColor,
      textDecoration: buttons.tertiary.hoverTextDecoration
    },

    '&:disabled': {
      color: buttons.tertiary.disabledColor,
      textDecoration: 'none',
      cursor: 'not-allowed'
    }
  },

  '@keyframes rotate': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  }
});
